<div class="container">
  <div class="subcontainer">
    <i class="material-icons check-icon">check_circle</i>
    <div>
      <span class="simple-title" [innerHTML]="data.titleHtml"></span>
      <span class="title">
        {{ data.title }}
      </span>
      @if (data.message) {
        <br>
        }
        <span class="description">
          {{ data.message }}
        </span>
      </div>
    </div>
    <button mat-icon-button class="exit_button close-icon" (click)="snackbarRef.dismiss()">
      <mat-icon>close</mat-icon>
    </button>

  </div>
